import { useState } from "react";
import StatusTag from "../components/StatusTag";
import { useMedicalCaseStatusHistory } from "../hooks/queries";
import { Tooltip } from "primereact/tooltip";
import { Dialog } from "primereact/dialog";
import { Divider } from "primereact/divider";
import { ProgressSpinner } from "primereact/progressspinner";

/**
 * Display the status of a case.
 * @author gabrielm
 * @param {object} props
 * @param {number} props.caseId
 * @param {string} props.caseStatus
 */
export default function CaseDetailDisplayStatus({ caseId, caseStatus }) {
  const [openDialog, setOpenDialog] = useState(false);

  return (
    <>
      <Tooltip target="#status-display" />
      <div
        id="status-display"
        data-pr-tooltip="Ver historial"
        data-pr-position="top"
        className="flex flex-column align-items-center justify-content-center text-lg cursor-pointer border-1 px-3 py-1 border-round-sm border-300"
        onClick={() => setOpenDialog(true)}
      >
        Estado:
        <StatusTag className="text-base" value={caseStatus} />
      </div>
      <StatusHistoryDialog
        caseId={caseId}
        visible={openDialog}
        onClose={() => {
          if (openDialog) setOpenDialog(false);
        }}
      />
    </>
  );

  // return (
  //   <div className="flex flex-column align-items-center justify-content-center text-lg">
  //     Estado:
  //     <StatusTag className="text-base" value={caseStatus} />
  //   </div>
  // );
}

function StatusHistoryDialog({ caseId, visible, onClose }) {
  const caseHistory = useMedicalCaseStatusHistory(caseId, {
    enabled: visible && !!caseId,
    select: (data) => {
      return data.status_history.map((item) => ({
        status: item.status,
        date: new Date(Date.parse(item.timestamp)).toLocaleString("es-ES", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        }),
        fullName: item.user_full_name,
        email: item.user_email,
        observation: item.observation,
      }));
    },
  });

  return (
    <Dialog
      visible={visible}
      onHide={onClose}
      draggable={false}
      header="Historial de cambios"
      className="w-7"
    >
      <div class="grid">
        {caseHistory.isLoading && <ProgressSpinner className="col-12" />}
        {caseHistory.data?.map((item) => (
          <>
            <div className="col-2">
              <StatusTag value={item.status} />
            </div>
            <div className="col-6 flex flex-column gap-2">
              <span>{item.fullName}</span>
              <span style={{ overflowWrap: "break-word" }}>{item.email}</span>
              <span>{item.date}</span>
            </div>
            <div className="col-4 flex flex-column gap-2">
              <span>
                <b>Observación:</b>
              </span>
              <span>{item.observation}</span>
            </div>
            <Divider className="col-12 my-0" />
          </>
        ))}
      </div>
    </Dialog>
  );
}
